import AnimalDetails from './AnimalDetails'
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'

function AnimalDetailsInModal({ UAI, setUAI }: { UAI: string; setUAI: any }) {
  return (
    <Dialog
      open={!!UAI}
      sx={{
        '& .MuiPaper-root': {
          maxWidth: 800,
        },
      }}
    >
      <DialogContent>
        <AnimalDetails modalUAI={UAI} />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setUAI('')}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}

export default AnimalDetailsInModal
